import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";
import Question from "../../containers/question/";
import NotificationSystem from "react-notification-system";

import {
  dataToJS,
  isLoaded,
  pathToJS,
  firebaseConnect
} from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";
class Log extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null
    };
    this.save = this.save.bind(this);
  }

  componentWillMount() {
    this.props.firebase.set(
      `/responses/groups/${this.props.match.params.groupId}/logs/${this.props.match.params.logId}/students/${this.props.auth.uid}/set`,
      true
    );
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  save() {
    this._notificationSystem = this.refs.notificationSystem;
    this._notificationSystem.addNotification({
      message: "Responses Saved!",
      level: "success"
    });
  }
  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    this.setState({ responses: this.props.responses });
  }

  updateQuestion({ value, groupId, questionId }) {
    console.log(this.props);
    this.props.firebase.set(
      `/responses/groups/${this.props.match.params.groupId}/logs/${this.props.match.params.logId}/students/${this.props.auth.uid}/group/${groupId}/question/${questionId}`,
      value
    );

    this.updatePercentage();
  }

  updatePercentage() {
    let complete = 0;
    let total = 0;

    if (this.props.log && this.props.responses && this.props.auth) {
      this.props.log.groups.map((group, groupIndex) => {
        group.questions.map((question, questionIndex) => {
          if (
            this.props.responses &&
            this.props.responses.group[groupIndex] &&
            this.props.responses.group[groupIndex].question[questionIndex] &&
            (this.props.responses.group[groupIndex].question[
              questionIndex
            ].value ||
              this.props.responses.group[groupIndex].question[
                questionIndex
              ].reason)
          ) {
            complete++;
          }
          total++;
        });
      });

      console.log(complete / total);
      this.props.firebase.set(
        `/percentages/groups/${this.props.match.params.groupId}/users/${this.props.auth.uid}/logs/${this.props.match.params.logId}`,
        {
          complete: complete,
          total: total,
          value: complete / total,
          createdAt: Date()
        }
      );
    }
  }

  render() {
    if (isLoaded(this.props.log) && isLoaded(this.props.responses)) {
      return (
        <div className="flex-container">
          <div className="toolbar">
            <DrawerToggle /> <h1>{this.props.log.title}</h1><h1
              className="button"
            >
              <button onClick={this.save}>
                Submit
              </button>
            </h1>
          </div>
          <div className="content log">
            <NotificationSystem ref="notificationSystem" />
            <div className="page">
              <div className="max-width">
                {this.props.log.directions &&
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: this.props.log.directions
                    }}
                  />}
                {this.props.log.groups.map(
                  (group, groupId) =>
                    group &&
                    <div
                      key={
                        `${this.props.match.params.groupId}${this.props.match.params.logId}${groupId}`
                      }
                    >
                      <h1>{group.title}</h1>
                      <div className="card">
                        {(group.questions || []).map((question, questionId) => (
                          <Question
                            key={
                              `${this.props.match.params.groupId}${this.props.match.params.logId}${groupId}${questionId}`
                            }
                            question={question}
                            value={
                              this.props.responses &&
                                this.props.responses.group &&
                                this.props.responses.group[groupId]
                                ? this.props.responses.group[groupId].question[
                                    questionId
                                  ]
                                : null
                            }
                            responses={this.props.responses}
                            log={this.props.log}
                            onChange={(value => {
                              this.updateQuestion({
                                groupId: groupId,
                                questionId: questionId,
                                value: value
                              });
                            }).bind(this)}
                          />
                        ))}
                      </div>
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <BlankPage />;
    }
  }
}

export default withRouter(
  connect(({ firebase }, { match, auth }) => {
    if (auth)
      return {
        groups: dataToJS(firebase, "/groups"),
        responses: dataToJS(
          firebase,
          `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students/${auth.uid}`
        ),
        log: dataToJS(firebase, `/logs/${match.params.logId}`)
      };
    return null;
  })(
    firebaseConnect(({ match, auth }) => {
      console.log(
        `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students/${auth.uid}`
      );
      return auth
        ? [
            "/logs",
            "/groups",
            `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students/${auth.uid}`
          ]
        : [];
    })(Log)
  )
);



// WEBPACK FOOTER //
// ./src/routes/log/index.js